import api from './api';

export const authorService = {
   getAll: async (params = {}) => {
      const response = await api.get('/authors', { params });
      return response.data;
   },

   getActive: async () => {
      const response = await api.get('/authors/active');
      return response.data;
   },

   getById: async (id) => {
      const response = await api.get(`/authors/${id}`);
      return response.data;
   },

   create: async (authorData) => {
      const response = await api.post('/authors', authorData);
      return response.data;
   },

   update: async (id, authorData) => {
      const response = await api.put(`/authors/${id}`, authorData);
      return response.data;
   },

   delete: async (id) => {
      const response = await api.delete(`/authors/${id}`);
      return response.data;
   },

   uploadImage: async (file) => {
      const formData = new FormData();
      formData.append('image', file);
      formData.append('uploadType', 'author');
      const response = await api.post('/authors/upload-image', formData, {
         headers: { 'Content-Type': 'multipart/form-data' },
      });
      return response.data;
   },
};
